module.exports = __webpack_public_path__ + "img/logo.e7d9c47e.png";